<section>
  <div class="d-flex flex-row justify-content-between align-items-center w-100">
    <h4 class="my-1">{{ mode }} floorplan</h4>

    <tr-icon [icon]="icon.cancel" (click)="close()" classes="close-btn"></tr-icon>
  </div>

  <form *ngIf="mode !== modalMode.delete" [formGroup]="form" class="mt-3">
    <div class="field-container pb-4">
      <div class="field-item">
        <label for="name" class="floorplan-builder-label">FLOORPLAN NAME*</label>
        <input
          id="name"
          formControlName="name"
          placeholder="Enter floorplan name"
          type="text"
          class="form-control"
        >

        <control-messages [control]="nameControl"></control-messages>
      </div>

      <div class="field-item d-flex mt-3">
        <input id="setDefault" type="checkbox" formControlName="default" />
        <label for="setDefault" class="mb-0 ml-2">Set as default</label>
      </div>
    </div>
  </form>

  <div class="field-container pb-3 pt-4" *ngIf="mode === modalMode.delete">
    <h2>You are about to delete floorplan “{{ item.name }}”. Do you want to delete all its tables as well?</h2>

    <div class="field-item d-flex mt-3">
      <input id="deleteResources" type="checkbox" [formControl]="deleteResources" />
      <label class="mb-0 ml-2" for="deleteResources">Yes, delete resources</label>
    </div>
  </div>

  <p
    *ngIf="mode === modalMode.edit"
    (click)="mode = modalMode.delete"
    class="delete mb-3 color-danger"
  >Delete floorplan</p>

  <div class="actions pt-3" *ngIf="mode !== modalMode.delete">
    <button class="btn btn-info mr-2 px-5" ngbAutoFocus (click)="submit()">{{ mode === modalMode.add ? 'Add' : 'Save Changes' }}</button>
    <button class="btn btn-danger ml-2 px-5" (click)="close()">Cancel</button>
  </div>

  <div class="actions pt-3" *ngIf="mode === modalMode.delete">
    <button class="btn btn-info mr-2 px-5" (click)="submit()">Confirm</button>
    <button class="btn btn-danger ml-2 px-5" (click)="mode = modalMode.edit">Decline</button>
  </div>
</section>
